import { MouseEvent, ReactNode } from 'react';
import Icon from './Icon';
import styles from './Button.module.css';

export type ButtonProps = {
  children?: ReactNode;
  variante?: 'primaria' | 'suave' | 'fantasma' | 'perigo' | 'contorno';
  tamanho?: 'sm' | 'md' | 'lg';
  icone?: string;
  carregando?: boolean;
  disabled?: boolean;
  onClick?: (evento: MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  /** Tooltip nativo — útil em botões só de ícone. */
  title?: string;
};

const classesVariante = {
  primaria: styles.primaria,
  suave: styles.suave,
  fantasma: styles.fantasma,
  perigo: styles.perigo,
  contorno: styles.contorno
};

const classesTamanho = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg
};

const tamanhoIcone = { sm: 16, md: 18, lg: 20 };

export default function Button({
  children,
  variante = 'primaria',
  tamanho = 'md',
  icone,
  carregando,
  disabled,
  onClick,
  type = 'button',
  title
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`${styles.botao} ${classesVariante[variante]} ${classesTamanho[tamanho]}`}
      disabled={disabled || carregando}
      onClick={onClick}
      title={title}
    >
      {carregando ? (
        <span className={styles.spinner} />
      ) : (
        icone && <Icon nome={icone} tamanho={tamanhoIcone[tamanho]} />
      )}
      {children}
    </button>
  );
}
